import React from 'react'
import './ProductDetail.css'

import { connect } from 'react-redux'

import { BsHeart } from "react-icons/bs";

import { addToCart, addToFavorites } from '../../Redux/Webshop/shop-actions'
const ProductDetail = ({ detail, addToCart, addToFavorites }) => {


    return (
        <>
            <div className='containerAll'>
            
                <div className='pDContainer'>
                    <img src={detail.image} className='imgPD' alt={detail.alt}/>
                </div>
                <div className='pDText'>
                    <p >{detail.title}</p>
                    <p >{detail.text}</p>
                    <p>{detail.description}</p>
                </div>
                <button onClick={() => addToCart(detail.id)} className='buttonPD'>add to basket</button>
                <button className='buttonFavorite'onClick={() => addToFavorites(detail.id)}><BsHeart style={{fontSize:"20px", marginBottom:"1vw"}}/></button>
            </div>

        </>
    )
}

const mapStateToProps = (state) => {
    return {
        detail: state.shop.currentItem
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (id) => dispatch(addToCart(id)),
        addToFavorites: (id) => dispatch(addToFavorites(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail)
